(function () {
	/* Productive #258 - the grid-size choice used to live only in the DOM: a
	   facets.js re-render, a reload or a paginated page put the grid back on the
	   section default. Persist the choice per session (same idiom as the Model
	   toggle, sessionStorage "plp-shot") and re-apply it on init, after Section
	   Rendering swaps and when the grid grows. */
	const STORAGE_KEY = "plp-per-row";

	const readStored = () => {
		try {
			const value = window.sessionStorage.getItem(STORAGE_KEY);
			return value === "small" || value === "large" ? value : null;
		} catch (e) {
			return null;
		}
	};

	const applyPerRow = (value) => {
		if (!value) return;
		$(".per-row__button").removeClass("active");
		$(`[data-per-row="${value}"]`).addClass("active");
		$("[data-productis-in-row]").attr("data-productis-in-row", value);
	};

	const productsPerRow = () => {
		$(".per-row__button")
			.off("click.perRow")
			.on("click.perRow", function () {
				const value = $(this).data("per-row");
				applyPerRow(value);
				try {
					window.sessionStorage.setItem(STORAGE_KEY, value);
				} catch (e) {
					/* non-fatal */
				}
			});
		applyPerRow(readStored());
	};

	document.addEventListener("shopify:section:load", function () {
		productsPerRow();
	});
	// facets.js swaps #ProductGridContainer's contents on filter / sort /
	// paginate (Section Rendering API); the buttons and the attribute host may
	// be re-rendered on the section default, so bind and re-apply after each swap.
	const grid = document.getElementById("ProductGridContainer");
	if (grid) {
		new MutationObserver(() => {
			window.requestAnimationFrame(productsPerRow);
		}).observe(grid, { childList: true, subtree: false });
	}
	document.addEventListener("plp:products-appended", () => applyPerRow(readStored()));
	productsPerRow();
})();
